import React, { useCallback } from "react";
import { Box, Typography, Grid, useMediaQuery } from "@mui/material";
import { applicationStepsData } from "../../data/applicationStepsData";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../services/redux/store";
import { whyChooseUsFeatures } from "../../data/whyChooseUsFeatures";
import { successStories } from "../../data/successStories";
import DoubleQuotes from "../../assets/svgIcons/double-quotes.svg";
import EligibilityCard from "../../components/ui/EligibilityCard";
import theme from "../../theme";
import "react-multi-carousel/lib/styles.css";
import {
  clearFormData,
  setActiveHorizontalIndex,
  setActiveVerticalIndex,
  setIsEmailVerified,
  setIsMobileVerified,
  setLastVerifiedEmail,
  setLastVerifiedPhoneNumber,
  setTrackingId,
  setApplicationId,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setIsEligibilityCheckSubmitted,
  setShowAadhaar,
  setHasPan,
  clearActiveIndex,
  setIsDocumentVerified,
  setAadhaarApplicationNo,
  clearNotInList,
  setCompletedHorizontalIndex,
  clearCoApplicantVerification,
  clearIsDocumentVerifiedCoApplicant,
  clearAadhaarApplicationNoCoApplicant,
  clearAadhaarVerifiedDetailsCoApplicant,
  clearAadhaarVerifiedDetails,
  setLastPanNumber,
  clearCheckIsLeadApiInvoked,
  setLeadSequenceId,
  clearSetLoanDetailCoApplicantCollapseValue,
  setAssignedSMIdValue,
  setDisplayHorizontalSteps,
  setAadhaarSeedingStatus,
  setIsEligible,
  setApplicationSource,
  clearSavedBasicCoApplicants,
  setFetchUserApplicationData,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import {
  setChatStatusConfig,
  setCurrentSessionId,
  setSalesUserId,
} from "../../services/redux/slices/chatSlice";
import { clearAllApplicantLoanDetails } from "../../services/redux/slices/applicationLoanDetailsSlice";
import DashboardJourny from "./Dashboard";
import { setOpenFirstTimeOnlyPopup } from "../../services/redux/slices/tabsSlice";
import LoanCardDashboard from '../../components/ui/LoanCardDashboard';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SECTION_SPACE = 3; // theme.spacing(4) = 32px typically
const HEADING_SPACE = 2; // theme.spacing(2) = 16px

const NewApplication: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.15,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.5,
      partialVisible: true,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1.5,
      partialVisible: true,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.1,
      partialVisible: true,
    },
  };

  // const handleClearData = () => {
  //   dispatch(setTrackingId(""));
  //   dispatch(setCompletedHorizontalIndex(null));
  //   dispatch(setActiveHorizontalIndex(0));
  //   dispatch(setActiveVerticalIndex(0));
  //   dispatch(clearActiveIndex());
  //   dispatch(clearFormData());
  //   dispatch(setLastVerifiedPhoneNumber(""));
  //   dispatch(setLastVerifiedEmail(""));
  //   dispatch(setIsDocumentVerified(false));
  //   dispatch(setIsMobileVerified(false));
  //   dispatch(setIsEmailVerified(false));
  //   dispatch(setIsPanVerified(false));
  //   dispatch(setPanNumber(""));
  //   dispatch(setAadhaarMandatory(false));
  //   dispatch(setIsEligibilityCheckSubmitted(false));
  //   dispatch(setShowAadhaar(false));
  //   dispatch(setHasPan(""));
  //   dispatch(setAadhaarApplicationNo(""));
  //   dispatch(clearNotInList());
  //   localStorage.removeItem("applicationNo");
  //   dispatch(clearCoApplicantVerification());
  //   dispatch(clearIsDocumentVerifiedCoApplicant());
  //   dispatch(clearAadhaarApplicationNoCoApplicant());
  //   dispatch(clearAadhaarVerifiedDetailsCoApplicant());
  //   dispatch(clearAadhaarVerifiedDetails());
  //   dispatch(setLastPanNumber(""));
  //   dispatch(clearCheckIsLeadApiInvoked());
  //   dispatch(setLeadSequenceId(""));
  //   dispatch(clearSetLoanDetailCoApplicantCollapseValue());
  //   dispatch(setAssignedSMIdValue(""));
  //   dispatch(setSalesUserId(""));
  //   dispatch(setCurrentSessionId(""));
  //   dispatch(setOpenFirstTimeOnlyPopup(null));
  //   dispatch(setDisplayHorizontalSteps([]));
  //   dispatch(clearAllApplicantLoanDetails());
  //   dispatch(setAadhaarSeedingStatus(null));
  //   dispatch(setIsEligible(false));
  //   dispatch(setApplicationSource(""));
  // };

  const handleClearData = useCallback(() => {
    dispatch(setApplicationId("")); // Clear application ID
    dispatch(setTrackingId(""));
    dispatch(setCompletedHorizontalIndex(null));
    dispatch(setActiveHorizontalIndex(0));
    dispatch(setActiveVerticalIndex(0));
    dispatch(clearActiveIndex());
    dispatch(clearFormData());
    dispatch(setLastVerifiedPhoneNumber(""));
    dispatch(setLastVerifiedEmail(""));
    dispatch(setIsDocumentVerified(false));
    dispatch(setIsMobileVerified(false));
    dispatch(setIsEmailVerified(false));
    dispatch(setIsPanVerified(false));
    dispatch(setPanNumber(""));
    dispatch(setAadhaarMandatory(false));
    dispatch(setIsEligibilityCheckSubmitted(false));
    dispatch(setShowAadhaar(false));
    dispatch(setHasPan(""));
    dispatch(setAadhaarApplicationNo(""));
    dispatch(clearNotInList());
    localStorage.removeItem("applicationNo");
    dispatch(clearCoApplicantVerification());
    dispatch(clearIsDocumentVerifiedCoApplicant());
    dispatch(clearAadhaarApplicationNoCoApplicant());
    dispatch(clearAadhaarVerifiedDetailsCoApplicant());
    dispatch(clearAadhaarVerifiedDetails());
    dispatch(setLastPanNumber(""));
    dispatch(clearCheckIsLeadApiInvoked());
    dispatch(setLeadSequenceId(""));
    dispatch(clearSetLoanDetailCoApplicantCollapseValue());
    dispatch(setAssignedSMIdValue(""));
    dispatch(setSalesUserId(""));
    dispatch(setCurrentSessionId(""));
    dispatch(setOpenFirstTimeOnlyPopup(null));
    dispatch(setDisplayHorizontalSteps([]));
    dispatch(clearAllApplicantLoanDetails());
    dispatch(setAadhaarSeedingStatus(null));
    dispatch(setIsEligible(false));
    dispatch(setApplicationSource(""));
    dispatch(clearSavedBasicCoApplicants());
    dispatch(setChatStatusConfig({}));
    // Reset so a fresh application never inherits data (e.g. a saved
    // Collateral Type, which would wrongly lock the new application's
    // Collateral Type dropdown as "already saved") left over in Redux/
    // persisted storage from a previously viewed application.
    dispatch(setFetchUserApplicationData([]));
  }, [dispatch]);

  return (
    <div className="new-application" style={{ pointerEvents: "auto" }}>
      {isXsOrSm ? <></> : <DashboardJourny activeTab={"new"} />}

      {/* Products Section */}
      <Box sx={{ mt: isXsOrSm ? 1 : 0, marginBottom: "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            className="section-heading"
            sx={{ fontSize: isXsOrSm ? "15px !important" : "" }}
          >
            Our Loan Products
          </Typography>
        </Box>

        <LoanCardDashboard handleClearData={handleClearData} />
      </Box>

      {/* Application Steps */}
      <Box
        sx={{
          my: isXsOrSm ? 0 : SECTION_SPACE,
          background: "#ffffff",
          color: "#FFF",
          borderRadius: "6px",
          p: 3,
          boxShadow: isXsOrSm ? "0px 4px 12px rgba(0, 0, 0, 0.1)" : "",
        }}
      >
        <Typography
          className="section-heading"
          sx={{ fontSize: isXsOrSm ? "15px !important" : "" }}
        >
          Your path to admission at your dream university
        </Typography>
        <EligibilityCard steps={applicationStepsData} showStepLabel={true} />
      </Box>

      {/* Why Choose Us */}
      <Box
        sx={{
          my: SECTION_SPACE,
          background: isXsOrSm ? "#ffffff" : "",
          borderRadius: isXsOrSm ? "6px" : "",
          p: isXsOrSm ? 3 : "",
          color: isXsOrSm ? "#FFF" : "",
          boxShadow: isXsOrSm ? "0px 4px 12px rgba(0, 0, 0, 0.1)" : "",
        }}
      >
        <Typography
          className="section-heading"
          sx={{ fontSize: isXsOrSm ? "15px !important" : "" }}
        >
          Why you should choose Avanse?
        </Typography>
        <Grid container spacing={3}>
          {whyChooseUsFeatures.map((feature: any, index: any) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  p: 2,
                  textAlign: "center",
                  minHeight: 200,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#FFF",
                  borderRadius: "6px",
                }}
              >
                <Box sx={{ fontSize: 40, mb: 1 }}>
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    style={{ maxWidth: 64 }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#5d586c",
                    mb: 1,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    fontSize: "13px",
                    color: "#4b4b4b",
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Success Stories */}
      <Box
        sx={{
          my: SECTION_SPACE,
          background:
            "linear-gradient(184.11deg, #00B3B5 3.68%, #00989A 47.06%, #008688 90.43%)",
          borderRadius: "6px",
          p: 3,
          color: "#FFF",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "15px",
            mb: HEADING_SPACE,
          }}
        >
          Success Stories
        </Typography>
        {isXsOrSm ? (
          <Box
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: 'hidden',
              "& .slick-list": {
                overflow: "visible", 
              },
              "& .slick-track": {
                display: "flex !important",
              },
              "& .slick-slide": {
                height: "inherit !important",
                paddingRight: "12px", 
              },
              "& .slick-dots": {
                bottom: "-25px",
                display: "flex !important",
                justifyContent: "center",
                alignItems: "center",
                listStyle: "none",
                padding: 0,
                "& li": {
                  margin: "0 4px",
                  width: "8px",
                  height: "8px",
                  "& button": {
                    width: "8px",
                    height: "8px",
                    padding: 0,
                    "&:before": {
                      content: '""',
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#FFFFFF",
                      opacity: 0.5,
                      position: "absolute",
                      top: 0,
                      left: 0,
                      transition: "all 0.3s ease",
                    },
                  },
                  "&.slick-active button:before": {
                    backgroundColor: "#FFFFFF",
                    opacity: 1,
                  },
                },
              },
              pb: 4,
            }}
          >
            <Slider {...settings}>
              {successStories.map((story: any, index: any) => (
                <Box key={index}>
                  <Box
                    sx={{
                      p: 2,
                      textAlign: "left",
                      minHeight: 220,
                      display: "flex",
                      flexDirection: "column",
                      background: "#FFF",
                      borderRadius: "6px",
                      color: "#4b4b4b",
                      height: "100%",
                    }}
                  >
                    <Typography variant="h4" color="primary" sx={{ mb: 1 }}>
                      <img src={DoubleQuotes} alt="double-quotes" />
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        mb: 1,
                      }}
                    >
                      {story.quote}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#008688",
                        mt: "auto",
                      }}
                    >
                      {story.author}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Slider>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {successStories.map((story: any, index: any) => (
              <Grid item xs={12} md={4} key={index}>
                <Box
                  sx={{
                    p: 2,
                    textAlign: "left",
                    height: 180,
                    display: "flex",
                    flexDirection: "column",
                    background: "#FFF",
                    borderRadius: "6px",
                    color: "#4b4b4b",
                  }}
                >
                  <Typography variant="h4" color="primary" sx={{ mb: 1 }}>
                    <img src={DoubleQuotes} alt="double-quotes" />
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      mb: 1,
                    }}
                  >
                    {story.quote}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#008688",
                      mt: "auto",
                    }}
                  >
                    {story.author}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default NewApplication;
